// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 778 ? "component---src-templates-index-js" : chunkId) + "-" + {"113":"eefaada3a2fcf3f00c4c","778":"11e51fc7d14a62761c1c"}[chunkId] + ".js";
};